import { render } from "./PatientInfoString.vue?vue&type=template&id=f65599f0"
import script from "./PatientInfoString.vue?vue&type=script&lang=js"
export * from "./PatientInfoString.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__